import { Toaster } from "react-hot-toast";

const ToasterContext = () => {
  return <Toaster />;
};
export default ToasterContext;
